import { EstimationInput } from '../../App';
import { EmissionCalculationInTonnes } from '../../configs/industryCalculationTemplate';
import { EmissionCategories, throwIfAnyUndefined } from '../calculations';

export const calculateRestaurant = (
  emissionsCategories: EmissionCategories,
  input: EstimationInput,
): EmissionCalculationInTonnes => {
  const { employees } = input;

  const {
    restaurant_vehicles_tonnes,
    restaurant_energy_tonnes,
    restaurant_refrigeration_tonnes,
    restaurant_electricity_tonnes,
    restaurant_freight_tonnes,
    restaurant_commuting_tonnes,
    restaurant_water_tonnes,
    restaurant_waste_tonnesr,
  } = emissionsCategories;

  throwIfAnyUndefined(
    [
      restaurant_vehicles_tonnes,
      restaurant_energy_tonnes,
      restaurant_refrigeration_tonnes,
      restaurant_electricity_tonnes,
      restaurant_freight_tonnes,
      restaurant_commuting_tonnes,
      restaurant_water_tonnes,
      restaurant_waste_tonnesr,
    ],
    'restaurant',
  );

  const tonnes =
    restaurant_vehicles_tonnes +
    restaurant_electricity_tonnes +
    restaurant_energy_tonnes +
    restaurant_freight_tonnes +
    restaurant_waste_tonnesr +
    restaurant_refrigeration_tonnes +
    restaurant_commuting_tonnes * employees +
    restaurant_water_tonnes;
  return tonnes;
};
